var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFffPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -158.676,
    y1: 19.9797,
    x2: 29.5773,
    y2: 19.9797,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C47DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDBCD4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,14.5c-0.4-1.8-1.3-3.2-2.9-4.3c-1.2-0.9-2.6-1.4-4.1-1.6c-1.9-0.3-3.9-0.2-5.7,0.5c-2,0.8-3.5,2-4.6,3.8 s-1.3,3.8-0.9,5.9c0.3,1.6,1.3,2.6,2.9,3c0.1,0,0.2,0,0.3-0.1c0.4-0.7,0.5-1.5,0.1-2.2c-0.2-0.4-0.5-0.8-0.6-1.2 c-0.4-1.5-0.2-3,0.7-4.4c0.8-1.3,1.8-2.2,3.2-2.8c2.2-0.9,4.3-1,6.3,0.3c0.9,0.6,1.5,1.4,1.9,2.5c0.3,1.2,0.4,2.4,0.2,3.6 c-0.2,1.5-0.7,2.9-1.6,4c-0.8,1-1.8,1.5-3.1,1.3c-1.2-0.2-1.8-0.8-1.7-2c0-0.7,0.2-1.4,0.4-2.1c0.3-1,0.7-2.1,0.8-3.2 c0.1-0.5,0-1-0.3-1.4c-0.7-1-2.3-1-3.2-0.1c-0.4,0.4-0.7,0.9-0.9,1.5c-0.4,1.2-0.4,2.3,0.1,3.5c0.1,0.1,0.1,0.3,0,0.4 c-0.4,1.6-0.8,3.2-1.2,4.9c-0.4,1.8-0.7,3.5-0.7,5.4c0,0.6,0.1,1.2,0.1,1.9c0.1-0.1,0.1-0.1,0.2-0.1c0.7-0.5,1.2-1.1,1.6-1.8 c0.7-1.2,1.1-2.5,1.5-3.9c0.2-0.7,0.3-1.3,0.5-2c0.3,0.2,0.5,0.3,0.8,0.5c0.7,0.4,1.3,0.8,2.1,0.9c2.1,0.2,3.9-0.4,5.4-1.8 c1.1-1.1,1.8-2.3,2.2-3.7C29.6,17.9,29.7,16.2,29.4,14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFffPinterest);
export default __webpack_public_path__ + "static/media/fff-pinterest.05e3a49dcb9888bc875821de6b6ab10f.svg";
export { ForwardRef as ReactComponent };